<template>
    <div class="myupleft">
        <Upload
                class="vertical_upload"
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                :multiple="false"
                type="drag"
                action=""
                :accept="accept"
                :style="'display: inline-block;vertical-align: top;border-radius:4px;width:' + width + 'px;' + 'height:' + height + 'px;' + 'border:'+ border ">

            <!--  没有图片时  -->
            <div v-if="uploadProgress == -1" class="upload_text">
                <div class="upload_text_icon">
                    <img v-if="addIcon == 'addIcon' " src="./images/add_icon.png" alt="">
                    <img v-else src="./images/add_file_icon.png" alt="">
                    <p v-if="tipsText!=''" class="upload_text_tips">{{ tipsText }}</p>
                </div>
            </div>

            <!--  图片上传时  -->
            <div v-else-if="uploadProgress == 1" class="upload_ing">
                <div class="upload_ing_text">识别中...</div>
            </div>

            <!--  图片上传成功  -->
            <div v-else-if="uploadProgress == 0" class="upload_success">
                <img class="upload_success_img"
                     :src="returnImg"
                     alt="">
                <div class="upload_success_btn">重新上传</div>
            </div>
        </Upload>
    </div>
</template>
<script>
    import {getHuaWeiToken} from '@/api/staticPage';
    import musicIcon from '@/assets/music_icon.png'
    import fileIcon from '@/assets/file_icon.png';
    import textIcon from '@/assets/text_icon.png';
    import videoIcon from '@/assets/video_icon.png';

    // import OBS from 'huawei-obs';
    const HWC_KEY = "https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar";
    const type = ['bat', 'exe', 'com', 'DLL', 'MSI', 'VBS', 'VBE', 'JS', 'JSE', 'WSH', 'WSF', 'PBD', 'PB', 'dmg', 'fcd', 'gdb', 'REG', 'SAV', 'str', 'SYS', 'swf', 'VBP', 'VBW', 'VBX', 'VIR', 'VXD', 'WCM', 'WIZ', 'A', 'ADF'];
    const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    String.prototype.suffix = function () {
        var index1 = this.lastIndexOf(".");
        var index2 = this.length;
        return this.substring(index1 + 1, index2)
    }
    var globalContext = {};
    globalContext.maxTaskNum = 5;
    globalContext.currentTaskNum = 0;

    const _doUpload = (obsClient, uploadPartStatus) => new Promise((res, rej) => {
        var events = require('events');
        var allDoneEe = new events.EventEmitter();
        doUploadPart(obsClient, uploadPartStatus, allDoneEe);
        allDoneEe.on('upload part finished', (result, _parts) => {
            res(result, _parts);
        });

        allDoneEe.on('error', (err) => {
            rej(err);
        });
    });

    const doUploadPart = (obsClient, uploadPartStatus, allDoneEe) => {
        while (uploadPartStatus.currentPartIndex < uploadPartStatus.partCount && globalContext.currentTaskNum < globalContext.maxTaskNum) {
            var offset = uploadPartStatus.currentPartIndex * uploadPartStatus.partSize;
            var currPartSize = (uploadPartStatus.currentPartIndex + 1 === uploadPartStatus.partCount) ? uploadPartStatus.fileSize - offset : uploadPartStatus.partSize;
            var partNumber = uploadPartStatus.currentPartIndex + 1;
            uploadPartStatus.currentPartIndex++;
            globalContext.currentTaskNum++;

            var getCallback = function (partNumber) {
                return function (result) {
                    globalContext.currentTaskNum--;
                    doUploadPart(obsClient, uploadPartStatus, allDoneEe);
                    if (result.CommonMsg.Status < 300) {
                        console.log('Part:' + partNumber + ' finished, etag:' + result.InterfaceResult.ETag);
                        uploadPartStatus.parts.push({PartNumber: partNumber, ETag: result.InterfaceResult.ETag});
                        if (uploadPartStatus.parts.length === uploadPartStatus.partCount) {
                            var _parts = uploadPartStatus.parts.sort(function (a, b) {
                                if (a.PartNumber >= b.PartNumber) {
                                    return 1;
                                }
                                return -1;
                            });
                            obsClient.completeMultipartUpload({
                                Bucket: uploadPartStatus.bucketName,
                                Key: uploadPartStatus.objectKey,
                                UploadId: uploadPartStatus.uploadId,
                                Parts: _parts
                            }, function (err, result) {
                                if (!err && result.CommonMsg.Status < 300) {
                                    console.log('Complete to upload multiparts finished.\n');
                                    allDoneEe.emit('upload part finished', result, _parts);
                                } else {
                                    var msg = err || result.CommonMsg.Code;
                                    console.error(msg);
                                    allDoneEe.emit('error', msg);
                                }
                            });
                        }
                    } else {
                        console.error(result.CommonMsg.Code);
                        allDoneEe.emit('error', result.CommonMsg.Code);
                    }
                }
            };

            obsClient.uploadPart({
                Bucket: uploadPartStatus.bucketName,
                Key: uploadPartStatus.objectKey,
                PartNumber: partNumber,
                UploadId: uploadPartStatus.uploadId,
                SourceFile: uploadPartStatus.file,
                Offset: offset,
                PartSize: currPartSize
            }).then(getCallback(partNumber)).catch(function (err) {
                console.error('err:' + err);
                allDoneEe.emit('error', err);
            });
        }
    };
    export default {
        name: 'my-upload-one-hw',
        props: {
            accept: {
                type: String,
                default: '*'
            },
            textContent: {
                type: String,
                default: '点击或拖拽上传文件'
            },
            documnetSize: {
                type: Number,
                default: 20971520
            },
            pictureSize: {
                type: Number,
                default: 20971520 * 5
            },
            videoAndMusicSize: {
                type: Number,
                default: 220971520 * 5 * 5
            },
            otherSize: {
                type: Number,
                default: 20971520 * 5 * 2
            },
            width: {
                type: Number,
                default: 130
            },
            height: {
                type: Number,
                default: 160
            },
            border: {
                type: String,
                default: '1px solid #CBCBCB;'
            },
            addIcon: {
                type: String,
                default: 'addIcon'
            },
            tipsText: {
                type: String,
                default: ''
            },
            preImg: {
                type: String,
                default: ''
            },


        },
        data() {
            return {
                uploadList: [],
                accessKeyId: '',
                accessKeySecret: '',
                stsToken: '',
                md5Hash: '',
                uploadProgress: -1,
                returnImg: '',
            }
        },
        watch: {

        },
        created(){
            if(this.preImg!=''){
                this.returnImg = this.preImg;
                this.uploadProgress = 0;
            }
        },
        methods: {
            handleSuccess(res, file) {
                file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                file.name = '7eb99afb9d5f317c912f08b5212fd69a';
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '超出单个对文件最大限制',
                    desc: '超出单个文件最大限制, 所有类型累计不能超过820M.'
                });
            },

            /*****************upload上传前的校验***************/
            handleBeforeUpload: async function (file) {
                let _this = this;
                _this.uploadProgress = 1;
                await this._getHuaWeiToken();
                console.log('111111111111111111');
                console.log("获取到的file文件", file, this.uploadList);
                var filetype = file.name.suffix();
                switch (true) {
                    case reImg.test(filetype):
                        if (file.size > _this.pictureSize) {
                            this.$Notice.warning({
                                title: '图片上传超出最大允许上线',
                                desc: '图片类文件大小不得超过' + Math.round(_this.pictureSize / 1024 / 1024) + 'MB'
                            });
                            _this.upLoadFail();
                            return false;
                        } else {
                            // this.uploadList.push(file)
                        }
                        break;
                    case reMusic.test(filetype):
                        if (file.size > _this.videoAndMusicSize) {
                            this.$Notice.warning({
                                title: '音频上传超出最大允许上线',
                                desc: '音频类文件大小不得超过' + Math.round(_this.videoAndMusicSize / 1024 / 1024) + 'MB'
                            });
                            _this.upLoadFail();
                            return false;
                        } else {
                            // this.uploadList.push(file)
                        }
                        break;
                    case reText.test(filetype):
                        if (file.size > _this.documnetSize) {
                            this.$Notice.warning({
                                title: '文档上传超出最大允许上限',
                                desc: '文档类文件大小不得超过' + Math.round(_this.documnetSize / 1024 / 1024) + 'MB'
                            });
                            _this.upLoadFail();
                            return false;
                        } else {
                            // this.uploadList.push(file)
                        }
                        break;
                    case reVideo.test(filetype):
                        if (file.size > _this.videoAndMusicSize) {
                            this.$Notice.warning({
                                title: '视频上传超出最大允许上线',
                                desc: '视频类文件大小不得超过' + Math.round(_this.videoAndMusicSize / 1024 / 1024) + 'MB'
                            });
                            _this.upLoadFail();
                            return false;
                        } else {
                            // this.uploadList.push(file)
                        }
                        break;
                    default:
                        if (file.size > _this.otherSize) {
                            this.$Notice.warning({
                                title: '文件上传超出最大允许上线',
                                desc: '除文档，图片，音视频类其他文件不得超过' + Math.round(_this.otherSize / 1024 / 1024) + 'MB'
                            });
                            _this.upLoadFail();
                            return false;
                        } else {
                            // this.uploadList.push(file)
                        }
                        break;
                }

                let fileReader = new FileReader(),
                    blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
                    chunkSize = 2097152,
                    chunks = Math.ceil(file.size / chunkSize),
                    currentChunk = 0,
                    spark = new SparkMD5.ArrayBuffer();
                const loadNext = () => {
                    var start = currentChunk * chunkSize,
                        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                };
                loadNext();
                fileReader.onload = (e) => {
                    spark.append(e.target.result);
                    currentChunk++;
                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        this.md5Hash = spark.end();
                        var mdfives = this.md5Hash
                        if (this.md5Hash != '') {
                            var partSize = 2097152;
                            var fileSize = file.size;
                            console.log('+++++++++++++++++++++++++', _this.accessKeyId, _this.accessKeySecret, _this.stsToken)
                            var obsClient = _this.getObsClient();
                            obsClient.initiateMultipartUpload({
                                Bucket: "anne-bqj-file",
                                Key: "file/" + mdfives + "." + file.name.substring(file.name.lastIndexOf(".") + 1)
                                // Key:"file/" + file.name
                            }).then(function (result) {
                                console.log('最终获取到华为云obs的结果', result)
                                var uploadId = result.InterfaceResult.UploadId;
                                console.log('uploadId:' + uploadId);
                                var partCount = fileSize % partSize === 0 ? Math.floor(fileSize / partSize) : Math.floor(fileSize / partSize) + 1;
                                console.log('partCount:' + partCount);
                                var uploadPartStatus = {
                                    bucketName: "anne-bqj-file",
                                    objectKey: result.InterfaceResult.Key,
                                    uploadId: uploadId,
                                    file: file,
                                    fileSize: fileSize,
                                    partSize: partSize,
                                    partCount: partCount,
                                    currentPartIndex: 0,
                                    parts: []
                                };
                                _doUpload(obsClient, uploadPartStatus).then((doneResult, _parts) => {
                                    console.log(`done signal is: ${doneResult}, ${_parts}`);
                                    let layout = uploadPartStatus.objectKey.substring(uploadPartStatus.objectKey.lastIndexOf(".") + 1);
                                    if (_this.fileMultiue) {
                                        _this.uploadList = _this.uploadList.concat([{
                                            uid: file.uid,
                                            name: file.name,
                                            status: 'done',
                                            type: file.type,
                                            md5Hash: mdfives,
                                            url: 'http://file.bqj.cn/' + result.InterfaceResult.Key,
                                            result: HWC_KEY + result.InterfaceResult.Key,
                                        }])
                                    } else {
                                        _this.uploadList = [{
                                            uid: file.uid,
                                            name: file.name,
                                            status: 'done',
                                            type: file.type,
                                            md5Hash: mdfives,
                                            url: 'http://file.bqj.cn/' + result.InterfaceResult.Key,
                                            result: HWC_KEY + result.InterfaceResult.Key,
                                        }]
                                    }
                                    if (_this.uploadList[0] && _this.uploadList[0].url != '') {
                                        let upLoadFileUrl = _this.uploadList[0].url;

                                        switch (true) {
                                            case reImg.test(filetype):
                                                _this.returnImg = upLoadFileUrl;
                                                break;

                                            case reMusic.test(filetype):
                                                _this.returnImg = musicIcon;
                                                break;

                                            case reText.test(filetype):
                                                _this.returnImg = textIcon;
                                                break;

                                            case reVideo.test(filetype):
                                                _this.returnImg = videoIcon;
                                                break;

                                            default:
                                                _this.returnImg = fileIcon;
                                                break;
                                        }

                                        _this.$emit("listenImgUrl", upLoadFileUrl);
                                        _this.uploadProgress = 0; //成功

                                    } else {
                                        _this.upLoadFail(true);
                                    }
                                    // _this.$emit("listenTochildEvent", _this.uploadList)
                                    return false;
                                }).catch(e => {
                                    console.error(e);
                                    _this.upLoadFail(true);
                                });
                            }).catch(e => {
                                console.error(e);
                                _this.upLoadFail(true);
                            });
                            return false
                        }
                    }
                }
                // this.getObsClient()
            },

            /*****************获取华为云token***************/
            _getHuaWeiToken: async function () {
                await getHuaWeiToken().then((res) => {
                    console.log('获取的华为云的临时cookie', res)
                    if (res.code == 200) {
                        this.accessKeyId = res.result.accessKeyId;
                        this.accessKeySecret = res.result.accessKeySecret;
                        this.stsToken = res.result.securityToken;
                    } else {
                        this.upLoadFail();
                    }
                })
            },

            /*****************华为云api封装***************/
            getObsClient() {
                let _this = this
                var obsClient = new window.ObsClient({
                    access_key_id: _this.accessKeyId,
                    secret_access_key: _this.accessKeySecret,
                    security_token: _this.stsToken,
                    server: "obs.cn-north-4.myhuaweicloud.com",
                    timeout: 60 * 5,
                })
                return obsClient;
            },

            /*****************上传失败***************/
            upLoadFail(showToast) {
                if (showToast) {
                    toast('上传解析失败，请重试');
                }

                this.uploadProgress = -1;
            }
        },
        mounted() {

        }
    }
</script>
<style scoped lang="less">
    /deep/ .vertical_upload.ivu-upload {
        width: 100%;
        height: 100%;
        display: flex;
    }

    /deep/ .vertical_upload .ivu-upload {
        width: 100%;
        height: 100%;
        display: flex;
    }

    /deep/ .ivu-upload-drag {
        border: none;
    }

    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .upload_success:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 2;
    }

    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background:#121210;
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #E82E31;
        border-color: #E82E31;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }

    .upload_text .upload_text_tips {
        padding-top: 10px;
        color: #333;
        font-size: 14px;
        line-height: 1;
    }

    /deep/ .ivu-date-picker .ivu-input {
        width: 100%;
    }
</style>